import { Grid, makeStyles } from '@material-ui/core'
import DazzedHeadingForGrid from 'components/common/text/DazzedHeadingForGrid'
import { NotifyPracticeReasons } from 'consts/giConsts'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PatientListTitle from '../../common/PatientsList/PatientListTitle'
import ReasonWithCount from './ReasonWithCount'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  title: {
    paddingLeft: 5,
    paddingBottom: 10
  },
  toggleButton: {
    margin: '2px 3px',
    height: 37,
    color: '#001335',
    backgroundColor: '#E7EAFF',
    borderRadius: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 10px',
    cursor: 'pointer'
  },
  allReasonsButton: {
    width: 96,
    height: 84,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: ({ allReasonsSelected }) => (allReasonsSelected ? '#7586FF' : '#E7EAFF')
  },
  reasonsContainer: {
    height: '50%'
  },
  allReasonsLabelsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  reasonLabelContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}))

const NeedsAttentionHeader = ({ total, countsByReasons, selectedReasons, setSelectedReasons }) => {
  const { t } = useTranslation()

  const [allReasonsSelected, setAllReasonsSelected] = useState(true)

  const classes = useStyles({ allReasonsSelected })

  const handleReasonClicked = useCallback(
    reason => {
      let newSelectedReasons = []

      if (selectedReasons.includes(reason)) {
        newSelectedReasons = selectedReasons.filter(r => r !== reason)
      } else {
        newSelectedReasons = [...selectedReasons, reason]
      }

      setSelectedReasons(newSelectedReasons)
    },
    [selectedReasons, setSelectedReasons]
  )

  useEffect(() => {
    if (selectedReasons.length === 0) {
      setAllReasonsSelected(true)
    } else {
      setAllReasonsSelected(false)
    }
  }, [selectedReasons])

  return (
    <Grid container className={classes.root}>
      <PatientListTitle />
      <Grid container>
        <Grid item>
          <Grid
            className={[classes.toggleButton, classes.allReasonsButton].join(' ')}
            style={{
              border: allReasonsSelected ? '2px solid #3C52EF' : 'none'
            }}
            onClick={() => setSelectedReasons([])}
          >
            <DazzedHeadingForGrid
              style={{
                paddingTop: 20,
                color: allReasonsSelected ? '#FFFFFF' : '#001335'
              }}
              bold
              xs={40}
            >
              {total}
            </DazzedHeadingForGrid>
            <DazzedHeadingForGrid
              style={{
                color: allReasonsSelected ? '#FFFFFF' : '#001335'
              }}
              semibold
              xs={10}
            >
              {t('pages.copilotControl.widgets.needsAttention.totalLabel')}
            </DazzedHeadingForGrid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container className={classes.reasonsContainer}>
            <ReasonWithCount
              containerClassName={classes.toggleButton}
              reason={NotifyPracticeReasons.Clinical}
              count={countsByReasons[NotifyPracticeReasons.Clinical]}
              onReasonClicked={handleReasonClicked}
              selected={selectedReasons.includes(NotifyPracticeReasons.Clinical)}
            />
            <ReasonWithCount
              containerClassName={classes.toggleButton}
              reason={NotifyPracticeReasons.Scheduling}
              count={countsByReasons[NotifyPracticeReasons.Scheduling]}
              onReasonClicked={handleReasonClicked}
              selected={selectedReasons.includes(NotifyPracticeReasons.Scheduling)}
            />
            <ReasonWithCount
              containerClassName={classes.toggleButton}
              reason={NotifyPracticeReasons.MissingInfo}
              count={countsByReasons[NotifyPracticeReasons.MissingInfo]}
              onReasonClicked={handleReasonClicked}
              selected={selectedReasons.includes(NotifyPracticeReasons.MissingInfo)}
            />
          </Grid>
          <Grid container className={classes.reasonsContainer}>
            <ReasonWithCount
              containerClassName={classes.toggleButton}
              reason={NotifyPracticeReasons.SpecificMembersAttention}
              count={countsByReasons[NotifyPracticeReasons.SpecificMembersAttention]}
              onReasonClicked={handleReasonClicked}
              selected={selectedReasons.includes(NotifyPracticeReasons.SpecificMembersAttention)}
            />
            <ReasonWithCount
              containerClassName={classes.toggleButton}
              reason={NotifyPracticeReasons.PatientQuestion}
              count={countsByReasons[NotifyPracticeReasons.PatientQuestion]}
              onReasonClicked={handleReasonClicked}
              selected={selectedReasons.includes(NotifyPracticeReasons.PatientQuestion)}
            />
            <ReasonWithCount
              containerClassName={classes.toggleButton}
              reason={NotifyPracticeReasons.Other}
              count={countsByReasons[NotifyPracticeReasons.Other]}
              onReasonClicked={handleReasonClicked}
              selected={selectedReasons.includes(NotifyPracticeReasons.Other)}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default NeedsAttentionHeader
